import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { DateTime } from 'luxon';
import { CheckCircleOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';

import { ReactComponent as NewIcon } from '../assets/icons/star.svg';

import OnTraccrButton from '../common/buttons/OnTraccrButton';
import Permissions from '../auth/Permissions';

export default function WorkflowCard({ workflow, setRelevantWorkflow, setImportWorkflow }) {
  const [isHovered, setIsHovered] = useState(false);
  const onMouseEnter = () => {
    setIsHovered(true);
  };
  const onMouseLeave = () => {
    setIsHovered(false);
  };
  const lastUpdated = workflow.lastUpdated ? DateTime.fromMillis(workflow.lastUpdated).toLocaleString(DateTime.DATE_SHORT) : 'N/A';
  return (
    <div className="workflow-card" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Row>
        <div className="workflow-card-icon" style={{ backgroundColor: workflow.color }}>
          <workflow.icon />
        </div>
        <div style={{ width: 'calc(100% - 56px)' }}>
          <div className="workflow-card-name">
            {workflow.name}
          </div>
          <div className="workflow-card-last-updated">
            Last updated {lastUpdated}
          </div>
          {(workflow.recentlyAdded || workflow.imported) && (
            <Row>
              {workflow.recentlyAdded && (
                <div className="workflow-card-recently-added">
                  <NewIcon className="workflow-card-recently-added-icon" />
                  <div className="workflow-card-recently-added-text">New</div>
                </div>
              )}
              {workflow.imported && (
                <div className="workflow-card-imported">
                  <CheckCircleOutlined className="workflow-card-imported-icon" />
                  <div className="workflow-card-imported-text">Imported</div>
                </div>
              )}
            </Row>
          )}
        </div>
      </Row>
      <Row className="workflow-card-short-description">
        {workflow.shortDescription}
      </Row>
      <Row className="workflow-card-categories">
        {workflow.categories.map((category) => (
          <div key={category} className="workflow-card-category">
            {category}
          </div>
        ))}
      </Row>
      {isHovered && (
        <Row className="workflow-card-buttons">
          <OnTraccrButton
            title="Details"
            icon={<EyeOutlined />}
            onClick={() => setRelevantWorkflow(workflow)}
            type="cancel"
            style={{ marginRight: 16, marginLeft: 'auto' }}
          />
          {Permissions.has('IMPORT_WORKFLOW_MARKETPLACE') && (
            <OnTraccrButton
              title="Import"
              icon={<DownloadOutlined />}
              onClick={() => setImportWorkflow(workflow)}
              style={{ marginRight: 'auto' }}
            />
          )}
        </Row>
      )}
    </div>
  );
}

WorkflowCard.propTypes = {
  workflow: PropTypes.shape({
    name: PropTypes.string.isRequired,
    lastUpdated: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    shortDescription: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    icon: PropTypes.elementType.isRequired,
    recentlyAdded: PropTypes.bool.isRequired,
    imported: PropTypes.bool.isRequired,
  }).isRequired,
  setRelevantWorkflow: PropTypes.func.isRequired,
  setImportWorkflow: PropTypes.func.isRequired,
};
